import { h, JSX } from 'preact'

export interface CheckboxProps {
    label: string
    name?: string
    checked?: boolean
    defaultChecked?: boolean
    onChange?: (checked: boolean) => void
    isDisabled?: boolean
}

export const Checkbox = (props: CheckboxProps): JSX.Element => (
    <div class="form-checkbox checkout__field">
        <div class="form-checkbox__inner">
            <label>
                <input
                    type="checkbox"
                    name={props.name}
                    checked={props.checked}
                    onChange={(event): void => props.onChange?.(event.currentTarget.checked)}
                    disabled={props.isDisabled}
                />
                {props.label}
            </label>
        </div>
    </div>
)
